import moment from 'moment';

const challengeModule = {
    namespaced: true,
    state: {
        challenge_uuid: null,
        challenge_1_boucle: {},
        challenge_2_boucles: {},
        challenge_3_boucles: {},
        challenge_6_boucles: {},
        challenge_12_boucles: {},
        challenge_infinity: {},
    },

    mutations: {
        buildChallenge(state, required_loops) {

            const current = {
                uuid: state.challenge_uuid,
                name: "",
                runner_results: [],
            };
            required_loops
                .forEach(loop => {
                    const runners = loop.runners;
                    runners.forEach(runner => {
                        if (((state.challenge_uuid == '6_boucles' && runner.course == "Challenge 6 boucles")
                            || (state.challenge_uuid == '2_boucles' && runner.course == "Challenge 2 boucles")
                            || (state.challenge_uuid == '3_boucles' && runner.course == "Challenge 3 boucles"
                                || (state.challenge_uuid == '1_boucle' && runner.course == "Challenge 1 boucle")
                                || (state.challenge_uuid == '12_boucles' && runner.course == "Challenge 12 boucles")
                                || (state.challenge_uuid == 'infinity' && runner.course == "Challenge Infinity"))) && runner.temps != '00:00:00') {
                            const runner_result = current.runner_results.find(runner_result => runner_result.dossard == runner.dossard);


                            if (runner_result === undefined) {
                                const new_runner_result = {
                                    dossard: runner.dossard,
                                    nom: runner.nom,
                                    prenom: runner.prenom,
                                    sexe: runner.sexe,
                                    annee_naissance: runner.annee_naissance,
                                    club: runner.club,
                                    categorie: runner.categorie,
                                    course: runner.course,
                                    temps_cumul: moment.duration(runner.temps).asMilliseconds(),

                                    abandon: runner.abandon,
                                    loop_results: [],
                                }
                                new_runner_result.loop_results.push({
                                    loop_id: loop.id,
                                    temps: runner.temps,
                                    classement: runner.classement,
                                    classement_sexe: runner.classement_sexe,
                                    classement_categorie: runner.classement_categorie,
                                });
                                current.runner_results.push(new_runner_result);


                            }
                            else {
                                runner_result.temps_cumul += moment.duration(runner.temps).asMilliseconds();

                                runner_result.loop_results.push({
                                    temps: runner.temps,
                                    classement: runner.classement,
                                    classement_sexe: runner.classement_sexe,
                                    classement_categorie: runner.classement_categorie,
                                    loop_id: loop.id,
                                });
                            }
                        }
                    });
                })

            const challenge = current;
            challenge.runner_results.sort((a, b) => {
                // get difference two duration with moment
                const a_nb_boucles = a.loop_results.length;
                const b_nb_boucles = b.loop_results.length;
                if (a_nb_boucles > b_nb_boucles) {
                    return -1;
                }
                if (a_nb_boucles < b_nb_boucles) {
                    return 1;
                }
                if (a_nb_boucles == b_nb_boucles) {

                    if (a.temps_cumul > b.temps_cumul) {
                        return 1;
                    }
                    if (a.temps_cumul < b.temps_cumul) {
                        return -1;
                    }

                }
                return 0;
            });
            /* let classement = 0;
            const classement_sexe = {};
            const classement_categorie = {};
            challenge.runner_results.forEach(runner_result => {
                classement++;
                if (!classement_sexe[runner_result.sexe]) {
                    classement_sexe[runner_result.sexe] = 0;
                }
                classement_sexe[runner_result.sexe]++;
                if (!classement_categorie[runner_result.categorie]) {
                    classement_categorie[runner_result.categorie] = 0;
                }
                classement_categorie[runner_result.categorie]++;
                runner_result.classement_cumul = classement;
                runner_result.classement_sexe_cumul = classement_sexe[runner_result.sexe];
                runner_result.classement_categorie_cumul = classement_categorie[runner_result.categorie];
            }); */


            switch (state.challenge_uuid) {
                case '1_boucle':
                    state.challenge_1_boucle = challenge;
                    break;
                case '3_boucles':
                    state.challenge_3_boucles = challenge;
                    break;
                case '6_boucles':
                    state.challenge_6_boucles = challenge;
                    break;
                case 'infinity':
                    state.challenge_infinity = challenge;
                    break;
                case '2_boucles':
                    state.challenge_2_boucles = challenge;
                    break;
                case '12_boucles':
                    state.challenge_12_boucles = challenge;
                    break;
            }


        },
        compute_classement(state, challenge) {

            challenge.runner_results.sort((a, b) => {
                // get difference two duration with moment
                const a_duration = moment.duration(a.temps_cumul);
                const b_duration = moment.duration(b.temps_cumul);
                const diff = a_duration.subtract(b_duration);
                if (diff.asMilliseconds() > 0) {
                    return 1;
                }
                if (diff.asMilliseconds() < 0) {
                    return -1;
                }
                return 0;
            });
            let classement = 0;
            const classement_sexe = {};
            const classement_categorie = {};
            challenge.runner_results.forEach(runner_result => {
                classement++;
                if (!classement_sexe[runner_result.sexe]) {
                    classement_sexe[runner_result.sexe] = 0;
                }
                classement_sexe[runner_result.sexe]++;
                if (!classement_categorie[runner_result.categorie]) {
                    classement_categorie[runner_result.categorie] = 0;
                }
                classement_categorie[runner_result.categorie]++;
                runner_result.classement_cumul = classement;
                runner_result.classement_sexe_cumul = classement_sexe[runner_result.sexe];
                runner_result.classement_categorie_cumul = classement_categorie[runner_result.categorie];
            });

            return challenge;

        }
    },
    actions: {

    },
    getters: {
        getChallenge(state) {
            return state.challenge_uuid;
        }
    }
}

export default challengeModule;